export const VISIBILITY_LABEL: Record<string, string> = {
	visibility_label: "Sichtbarkeit",
};
